<template>
  <div>Direct</div>
</template>

<script>
export default {}
</script>
